import { render, staticRenderFns } from "./InfoDeposit.vue?vue&type=template&id=00440299&scoped=true"
import script from "./InfoDeposit.vue?vue&type=script&lang=js"
export * from "./InfoDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00440299",
  null
  
)

export default component.exports